import { commonTableBodyStyles, commonTableHeadStyles } from '../commonStyled';

const commonCellStyles = {
  width: '132px',
  borderColor: ({ palette }) => `${palette.border.default} !important`,

  '&:first-of-type': {
    width: '320px',
  },
};

const commonTextStyles = {
  fontSize: '1.4rem',
};

export const tableHeadStyles = {
  '& .table-cell': {
    ...commonCellStyles,
    ...commonTextStyles,
    ...commonTableHeadStyles,
  },
};

export const tableBodyStyles = {
  '& .table-cell': {
    ...commonCellStyles,
    ...commonTextStyles,
    ...commonTableBodyStyles,
  },

  '& .table-row:last-of-type .table-cell': {
    border: 'none',
  },
};

export const footerCellStyles = {
  '&:first-of-type': {
    width: '300px',
  },
  '&:not(:first-of-type)': {
    width: '132px',
    fontWeight: '700 !important',
    color: ({ palette }) => `${palette.primary.main} !important`,
  },
};
